module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 1-cb4d33370e732133ee2cf090236f15aa.jpg";